import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { FacilityBedsDto } from '../../dtos-v2/facility-beds.dto';

@Pipe({
  name: 'capacityReportingPeriod',
  standalone: true,
  pure: true,
})
export class CapacityReportingPeriodPipe implements PipeTransform {
  private datePipe: DatePipe = new DatePipe('en-US');
  transform(
    dataEntry: FacilityBedsDto | undefined,
    reportingPeriod: 'week' | 'due' | 'completed' = 'week'
  ): string {
    if (!dataEntry) {
      return '';
    }

    // Format dates as MMMM d
    const format = 'MMMM d';
    const formatDate = (d: Date) => {
      return this.datePipe.transform(d, format) ?? 'unknown';
    };

    if (reportingPeriod === 'due') {
      return formatDate(dataEntry.dateDue);
    }
    if (reportingPeriod === 'completed' && dataEntry.completedOn) {
      return formatDate(dataEntry.completedOn);
    }

    return `${formatDate(dataEntry.datePeriodStart)}–${formatDate(
      dataEntry.datePeriodEnd
    )}`;
  }
}
